import React from "react";
import { motion } from "framer-motion"; // Import Framer Motion
import "../../assets/styles/comtree.css";
import bb5 from "../../assets/images/bb5.png"; // Logo
import bb1 from "../../assets/images/bb1.png";
import bb2 from "../../assets/images/bb2.png";
import bb3 from "../../assets/images/bb3.png";
import bb4 from "../../assets/images/bb4.png";

const ComThree = () => {
  return (
    <div
      className="comthree-container"
 
    >
      {/* Animated Logo Section */}
      <motion.div
        className="logo-container"
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.2, ease: "easeInOut" }}
      >
        <img src={bb5} alt="Commceed Logo" className="logo-image" />
      </motion.div>

      {/* Content Wrapper */}
      <div className="content-wrapper">
        {/* Animated Description Section */}
        <motion.p
          className="descriptionmm"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5, ease: "easeInOut", delay: 0.2 }}
        >
          At commceed, we don’t just deliver products; we deliver forward-thinking solutions 
          that power your network, elevate your infrastructure, and keep you ahead of the curve. 
          With every cable, every connection, and every system we provide, we turn complex 
          challenges into seamless experiences, transforming your ideas into reality with 
          precision and expertise.
        </motion.p>

        {/* Animated Image Grid */}
        <motion.div
          className="icons-grid"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          transition={{ staggerChildren: 0.3 }}
        >
          {[
            { src: bb1, alt: "Products", label: "PRODUCTS", marginTop: "20px" },
            { src: bb2, alt: "Countries", label: "COUNTRIES", marginTop: "20px" },
            { src: bb3, alt: "Customers", label: "CUSTOMERS", marginTop: "60px" },
            { src: bb4, alt: "Partnership", label: "PARTNERSHIP", marginTop: "20px" },
          ].map((item, idx) => (
            <motion.div
              key={idx}
              className="icon-box"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.2, ease: "easeInOut", delay: idx * 0.3 }}
              whileHover={{ scale: 1.1 }}
            >
              <img src={item.src} alt={item.alt} className="icon-image" />
              <p style={{ marginTop: item.marginTop }}>{item.label}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default ComThree;
